import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordDirective } from './show-password/show-password.directive';
import { EventListenerDirective } from './event-listener/event-listener.directive';
import { PhoneFormatterDirective } from './phone-formatter/phone-formatter.directive'
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from './tooltip/tooltip.directive';

@NgModule({
  declarations: [PasswordDirective, EventListenerDirective, PhoneFormatterDirective, TooltipDirective],
  exports: [
    PasswordDirective,
    EventListenerDirective,
    PhoneFormatterDirective,
    TooltipDirective
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class SharedDirectivesModule { }
